/**
 * Every place this application can be, named once.
 *
 * Real paths rather than a view held in a store: this is a management console
 * whose pages are worth linking to, reloading on, and reaching with the back
 * button — and the deployment already serves the single-page fallback that
 * makes a reload on one of them work.
 *
 * Nothing identifying appears in any of them. A path here names a page, never
 * an account, a device or a project.
 */
export const ROUTES = {
  account: "/account",
  catalog: "/catalog",
  devices: "/devices",
  home: "/",
  settings: "/settings",
  shelves: "/shelves",
} as const;
